import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router'
import './design/global.css'
import { trackKeyboardInset } from './design/keyboardInset'
import { AuthProvider } from './auth/AuthProvider'
import './auth/devHook'
import { ErrorBoundary } from './app/ErrorBoundary'
import { createQueryClient } from './app/queryClient'
import { router } from './app/router'
import { registerServiceWorker } from './pwa/register'

const container = document.getElementById('root')
if (container === null) throw new Error('Missing #root element.')

const queryClient = createQueryClient()

// Before the render, and outside the auth guard: the offline shell has to be installed for
// whoever opens the app, not only for someone already signed in. No-ops in dev.
void registerServiceWorker()

// Also outside the render: the keyboard covers the page whether or not anyone is signed
// in, and the sign-in form has fields of its own.
trackKeyboardInset()

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
)
